import { Component, OnInit } from '@angular/core';
/* Imports */
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { Proceso, Mes, Empresa } from 'src/app/classes/coordinador';
import { ApiProcesosService } from 'src/app/shared/services/api-procesos.service';
import { ApiEstadisticasService } from 'src/app/shared/services/api-estadisticas.service';
import { ApiEmpresasService } from 'src/app/shared/services/api-empresas.service';
import am4lang_ES from '@amcharts/amcharts4/lang/es_ES';

@Component({
  selector: 'app-metricas-empresa',
  templateUrl: './metricas-empresa.component.html',
  styleUrls: ['./metricas-empresa.component.css']
})
export class MetricasEmpresaComponent implements OnInit {
  // Loading
  loadingProcesos;
  loadingEmpresas;
  loadingEvolucion;
  loadingEvolucionAtraso;

  // Filtros
  filtros: {
    procesos: Proceso[];
    empresas: Empresa[];
    annos: number[];
    meses: Mes[];
  };

  filtrosSeleccionados: {
    proceso: Proceso;
    empresa: Empresa;
    anno: number;
    mes: Mes;
  };

  // Data
  metricasEmpresa;

  // Mensajeria
  errorEvolucion;
  errorEvolucionAtraso;

  constructor(
    private apiProcesoService: ApiProcesosService,
    private apiEmpresasService: ApiEmpresasService,
    private apiEstadisticasService: ApiEstadisticasService
  ) {}

  ngOnInit() {
    this.inicializarFiltros();
    this.cargarProcesos();
    this.cargarEmpresas();
    this.cargarAnnos();
    this.cargarMeses();

    am4core.useTheme(am4themes_animated);
  }

  inicializarFiltros() {
    this.filtros = {
      procesos: [],
      empresas: [],
      annos: [],
      meses: []
    };
    this.filtrosSeleccionados = {
      proceso: undefined,
      empresa: undefined,
      anno: undefined,
      mes: undefined
    };
    this.filtrosSeleccionados.anno = new Date(
      new Date().getFullYear(),
      new Date().getMonth() - 1,
      1
    ).getFullYear();
  }

  cargarProcesos() {
    this.loadingProcesos = true;
    this.apiProcesoService
      .getProcesos()
      .then((procesos: any) => {
        this.filtros.procesos = procesos;
        this.loadingProcesos = false;
      })
      .catch(() => {
        this.loadingProcesos = false;
      });
  }

  cargarEmpresas() {
    this.loadingEmpresas = true;
    this.apiEmpresasService
      .getEmpresas()
      .then((res: any) => {
        this.filtros.empresas = res;
        this.filtros.empresas = this.filtros.empresas.filter(
          item => item.sigla !== null
        );
        this.filtros.empresas.sort(function(a, b) {
          if (a.sigla < b.sigla) {
            return -1;
          }
          if (a.sigla > b.sigla) {
            return 1;
          }
          return 0;
        });
        this.loadingEmpresas = false;
      })
      .catch(error => {
        this.loadingEmpresas = false;
        console.error(error);
      });
  }

  todosLosFiltrosSeleccionados() {
    return (
      this.filtrosSeleccionados.proceso &&
      this.filtrosSeleccionados.empresa &&
      this.filtrosSeleccionados.anno
    );
  }

  cargarGraficos() {
    if (this.todosLosFiltrosSeleccionados()) {
      this.cargarMetricas();
    }
  }

  cargarMetricas() {
    this.loadingEvolucion = true;
    this.loadingEvolucionAtraso = true;
    this.errorEvolucion = undefined;
    this.errorEvolucionAtraso = undefined;

    this.apiEstadisticasService
      .metricaEmpresas(
        this.filtrosSeleccionados.empresa,
        this.filtrosSeleccionados.proceso,
        this.filtrosSeleccionados.anno,
        this.filtrosSeleccionados.mes
      )
      .then(res => {
        this.metricasEmpresa = res;
        this.loadingEvolucion = false;
        this.loadingEvolucionAtraso = false;

        setTimeout(() => {
          if (this.metricasEmpresa && this.metricasEmpresa.length > 0) {
            this.crearGraficoEvolucion();
            this.crearGraficoEvolucionAtraso();
          } else {
            this.errorEvolucion =
              'No existen datos para esta métrica con los filtros seleccionados.';

            this.errorEvolucionAtraso =
              'No existen datos para esta métrica con los filtros seleccionados.';
          }
        }, 100);
      })
      .catch(error => {
        this.loadingEvolucion = false;
        this.loadingEvolucionAtraso = false;
      });
  }

  crearGraficoEvolucion() {
    // Create chart instance
    const chart = am4core.create('evolucion', am4charts.XYChart);
    chart.language.locale = am4lang_ES;

    chart.data = [];

    for (const metricaEmpresa of this.metricasEmpresa) {
      chart.data.push({
        estado: metricaEmpresa.cumplio ? 1 : -1,
        mes:
          metricaEmpresa.mes.length === 1
            ? metricaEmpresa.anio + '-0' + metricaEmpresa.mes + '-01'
            : metricaEmpresa.anio + '-' + metricaEmpresa.mes + '-01'
      });
    }

    // Create axes
    const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.location = 0;
    dateAxis.renderer.minGridDistance = 50;
    dateAxis.renderer.grid.template.strokeOpacity = 0;

    chart.dateFormatter = new am4core.DateFormatter();
    chart.dateFormatter.dateFormat = 'yyyy-MM-dd';
    chart.dateFormatter.inputDateFormat = 'yyyy-MM-dd';

    // dateAxis.dateFormatter = new am4core.DateFormatter();
    // dateAxis.dateFormatter.dateFormat = 'yyyy-MM-dd';

    // Create value axis
    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.grid.template.strokeOpacity = 0;
    valueAxis.min = -1;
    valueAxis.max = 1;
    valueAxis.strokeWidth = 3;
    valueAxis.renderer.labels.template.disabled = true;

    const rangeCumple = valueAxis.axisRanges.create();
    rangeCumple.value = 0;
    rangeCumple.endValue = 1;
    rangeCumple.label.text = 'Cumple';
    rangeCumple.label.disabled = false;
    rangeCumple.label.adapter.add('horizontalCenter', function() {
      return 'middle';
    });

    const rangeNoCumple = valueAxis.axisRanges.create();
    rangeNoCumple.value = 0;
    rangeNoCumple.endValue = -1;
    rangeNoCumple.label.text = 'No Cumple';
    rangeNoCumple.label.disabled = false;
    rangeNoCumple.label.adapter.add('horizontalCenter', function() {
      return 'middle';
    });

    // Create series
    const series = chart.series.push(new am4charts.LineSeries());
    series.dataFields.valueY = 'estado';
    series.dataFields.dateX = 'mes';
    series.strokeWidth = 3;
    series.fillOpacity = 0.1;

    // Make bullets grow on hover
    const bullet = series.bullets.push(new am4charts.CircleBullet());
    bullet.circle.strokeWidth = 2;
    bullet.circle.radius = 4;
    bullet.circle.fill = am4core.color('#fff');
    // Create a range to change stroke for values below 0
    // const range = valueAxis.createSeriesRange(series);
    // range.value = 0;
    // range.endValue = -1000;
    // range.contents.stroke = chart.colors.getIndex(4);
    // range.contents.fill = range.contents.stroke;
    // range.contents.strokeOpacity = 0.7;
    // range.contents.fillOpacity = 0.1;

    // Export
    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.filePrefix =
      'Cumplimiento_' +
      this.filtrosSeleccionados.proceso.sigla +
      this.filtrosSeleccionados.anno +
      '_' + this.filtrosSeleccionados.empresa.sigla;
  }

  crearGraficoEvolucionAtraso() {
    // Create chart instance
    const chart = am4core.create('evolucionAtraso', am4charts.XYChart);
    chart.language.locale = am4lang_ES;

    chart.data = [];

    for (const metricaEmpresa of this.metricasEmpresa) {
      chart.data.push({
        atraso: parseInt(metricaEmpresa.diaAtraso, 0),
        mes:
          metricaEmpresa.mes.length === 1
            ? metricaEmpresa.anio + '-0' + metricaEmpresa.mes + '-01'
            : metricaEmpresa.anio + '-' + metricaEmpresa.mes + '-01'
      });
    }

    // Create axes
    const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.location = 0;
    dateAxis.renderer.minGridDistance = 50;
    dateAxis.renderer.grid.template.strokeOpacity = 0;

    dateAxis.title.text = 'Mes';
    dateAxis.title.fontWeight = '600';

    // Create value axis
    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.grid.template.strokeOpacity = 0;
    valueAxis.min = 0;
    valueAxis.max = 35;
    valueAxis.strictMinMax = true;
    valueAxis.strokeWidth = 3;
    valueAxis.renderer.line.strokeWidth = 3;
    valueAxis.renderer.line.stroke = am4core.color('#000');
    valueAxis.renderer.line.strokeOpacity = 1;

    valueAxis.title.text = 'Días de atraso';
    valueAxis.title.fontWeight = '600';

    // Create series
    const series = chart.series.push(new am4charts.LineSeries());
    series.dataFields.valueY = 'atraso';
    series.dataFields.dateX = 'mes';
    series.strokeWidth = 3;
    series.fillOpacity = 0.1;

    // Make bullets grow on hover
    const bullet = series.bullets.push(new am4charts.CircleBullet());
    bullet.circle.strokeWidth = 2;
    bullet.circle.radius = 4;
    bullet.circle.fill = am4core.color('#fff');
    bullet.circle.tooltipText =
      '[bold]Días:[/] {valueY}';

    // Create a range to change stroke for values below 0
    // const range = valueAxis.createSeriesRange(series);
    // range.value = 0;
    // range.endValue = -1000;
    // range.contents.stroke = chart.colors.getIndex(4);
    // range.contents.fill = range.contents.stroke;
    // range.contents.strokeOpacity = 0.7;
    // range.contents.fillOpacity = 0.1;

    // Export
    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.filePrefix =
      'DiasAtraso_' +
      this.filtrosSeleccionados.proceso.sigla +
      this.filtrosSeleccionados.anno +
      '_' + this.filtrosSeleccionados.empresa.sigla;
  }

  cargarAnnos() {
    const primerAnno = new Date(
      new Date().getFullYear(),
      new Date().getMonth() + -1,
      1
    ).getFullYear();

    for (let i = primerAnno; i > primerAnno - 10 && i >= 2018; i--) {
      this.filtros.annos.push(i);
    }
  }

  cargarMeses() {
    this.filtrosSeleccionados.mes = undefined;

    this.filtros.meses = [
      {
        nombre: 'Enero',
        sigla: 'Ene',
        numero: 1,
        bloqueado: false
      },
      {
        nombre: 'Febrero',
        sigla: 'Feb',
        numero: 2,
        bloqueado: false
      },
      {
        nombre: 'Marzo',
        sigla: 'Mar',
        numero: 3,
        bloqueado: false
      },
      {
        nombre: 'Abril',
        sigla: 'Abr',
        numero: 4,
        bloqueado: false
      },
      {
        nombre: 'Mayo',
        sigla: 'May',
        numero: 5,
        bloqueado: false
      },
      {
        nombre: 'Junio',
        sigla: 'Jun',
        numero: 6,
        bloqueado: false
      },
      {
        nombre: 'Julio',
        sigla: 'Jul',
        numero: 7,
        bloqueado: false
      },
      {
        nombre: 'Agosto',
        sigla: 'Ago',
        numero: 8,
        bloqueado: false
      },
      {
        nombre: 'Septiembre',
        sigla: 'Sep',
        numero: 9,
        bloqueado: false
      },
      {
        nombre: 'Octubre',
        sigla: 'Oct',
        numero: 10,
        bloqueado: false
      },
      {
        nombre: 'Noviembre',
        sigla: 'Nov',
        numero: 11,
        bloqueado: false
      },
      {
        nombre: 'Diciembre',
        sigla: 'Dic',
        numero: 12,
        bloqueado: false
      }
    ];

    if (new Date().getFullYear() === this.filtrosSeleccionados.anno) {
      const mesActual = new Date().getMonth() + 1;
      for (const mes of this.filtros.meses) {
        mes.bloqueado = mes.numero >= mesActual;
      }
    }
  }
}
